import axios from 'axios';

const ROUTE = '/rest/v4/deviations';

export default {

    getDeviation(id) {
        return axios.get(`${ROUTE}/${id}`);
    },

    confirmDeviation(id, data) {
        return axios.post(`${ROUTE}/${id}/confirm`, data);
    },

    rejectDeviation(id, data) {
        return axios.post(`${ROUTE}/${id}/reject`, data);
    },

    patchDeviation(id, data) {
        return axios.patch(`${ROUTE}/${id}`, data);
    }
}
